<div>
	<form [formGroup]="terceroCreateForm">
		<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
			<mat-form-field appearance="outline" fxFlex>
				<mat-label>Es consorcio  o unión temporal*</mat-label>
				<mat-icon matPrefix>supervised_user_circle</mat-icon>
				<mat-select class="pl-12" name="unionTemporalConsorcio" formControlName="unionTemporalConsorcio">
					<mat-option [value]="true">SI</mat-option>
					<mat-option [value]="false">NO</mat-option>
				</mat-select>
				<mat-error *ngIf="terceroCreateForm.get('unionTemporalConsorcio').hasError('required')">Campo obligatorio</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline" fxFlex  *ngIf="terceroCreateForm.get('unionTemporalConsorcio').value">
				<mat-label>Tipo tercero*</mat-label>
				<mat-icon matPrefix>touch_app</mat-icon>
				<mat-select class="pl-12" name="consorcioUnionTemporal" formControlName="consorcioUnionTemporal">
					<mat-option *ngFor="let tipoTercero of tiposTerceros" [value]="tipoTercero.id">{{tipoTercero.name}}</mat-option>
				</mat-select>
				<mat-error *ngIf="terceroCreateForm.get('consorcioUnionTemporal').hasError('required')">Campo obligatorio</mat-error>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
			<mat-form-field appearance="outline" fxFlex>
				<mat-label>Tipo Persona*</mat-label>
				<mat-icon matPrefix>supervised_user_circle</mat-icon>
				<mat-select class="pl-12" name="tipoPersona" formControlName="tipoPersona" (ngModelChange)='CambioTipoPersona()'>
					<mat-option [value]="'Natural'">Natural</mat-option>
					<mat-option [value]="'Juridica'">Jurídica</mat-option>
					<!-- <mat-option *ngFor="let unidad of unidadesEjecutoras" [value]="unidad.codigo">{{unidad.codigo}} - {{unidad.nombre}}</mat-option> -->
				</mat-select>
				<mat-error *ngIf="terceroCreateForm.get('tipoPersona').hasError('required')">Campo obligatorio</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline" fxFlex>
				<mat-label>Tipo Vinculación*</mat-label>
				<mat-icon matPrefix>touch_app</mat-icon>
				<mat-select class="pl-12" name="tipoVinculacion" formControlName="tipoVinculacion">
					<mat-option [value]="'Proveedor'">Proveedor</mat-option>
					<mat-option [value]="'Funcionario'">Funcionario</mat-option>
					<!-- <mat-option *ngFor="let unidad of unidadesEjecutoras" [value]="unidad.codigo">{{unidad.codigo}} - {{unidad.nombre}}</mat-option> -->
				</mat-select>
				<mat-error *ngIf="terceroCreateForm.get('tipoVinculacion').hasError('required')">Campo obligatorio</mat-error>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" *ngIf="terceroCreateForm.get('tipoPersona').value == 'Juridica'">
			<mat-form-field appearance="outline" fxFlex>
				<mat-label>Orden*</mat-label>
				<mat-icon matPrefix>sensors</mat-icon>
				<mat-icon matSuffix matTooltipPosition='above' matTooltip="Orden de la entidad contratista, en caso de ser entidad privada seleccionar NO APLICA">help</mat-icon>
				<mat-select class="pl-12" name="ordenTercero" formControlName="ordenId">
					<mat-option [value]="0">Seleccione una Opción</mat-option>
					<mat-option *ngFor="let item of ordenesTercero" [value]="item.id">{{item.name}}</mat-option>
				</mat-select>
				<mat-hint>Orden de la entidad contratista, en caso de ser entidad privada seleccionar NO APLICA</mat-hint>
				<mat-error *ngIf="terceroCreateForm.get('ordenId').hasError('required')">Campo obligatorio</mat-error>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
			<mat-form-field appearance="outline" fxFlex="30">
				<mat-label>Tipo Identificación*</mat-label>
				<mat-icon matPrefix>bookmark</mat-icon>
				<mat-select class="pl-12" name="tipoIdentificacion" formControlName="tipoIdentificacion" (ngModelChange)='CambioTipoIdentificacion()'>
					<mat-option [value]="'CC'">CC</mat-option>
					<mat-option [value]="'CE'">CE</mat-option>
					<mat-option [value]="'NIT'">NIT</mat-option>
					<!-- <mat-option *ngFor="let unidad of unidadesEjecutoras" [value]="unidad.codigo">{{unidad.codigo}} - {{unidad.nombre}}</mat-option> -->
				</mat-select>
				<mat-error *ngIf="terceroCreateForm.get('tipoIdentificacion').hasError('required')">Campo obligatorio</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline" fxFlex>
				<mat-label>Identificación*</mat-label>
				<button matSuffix mat-icon-button matTooltipPosition='above' matTooltip="Si el tercero es union temporal y aún no tiene NIT, no digite este campo.">
					<mat-icon>help</mat-icon>
				</button>
				<mat-icon matPrefix>person</mat-icon>
				<input type="text" name="identificacion" formControlName="identificacion" [mask]='mascara' autocomplete="none" matInput (change)="CambioIdentificacion()" autocomplete="none">
				<mat-hint *ngIf="terceroCreateForm.get('unionTemporalConsorcio').value">Si el consorcio o unión temporal aún no tiene NIT, por favor no digite este campo.</mat-hint>
				<mat-error *ngIf="terceroCreateForm.get('identificacion').hasError('required')">Campo obligatorio</mat-error>
			</mat-form-field>

			<mat-form-field appearance="outline" fxFlex="20" *ngIf="terceroCreateForm.get('tipoPersona').value == 'Juridica' || terceroCreateForm.get('tipoIdentificacion').value == 'NIT'">
				<mat-label>Dv*</mat-label>
				<input type="text" name="digitoVerificacion" formControlName="dv" matInput autocomplete="none">
				<mat-error *ngIf="terceroCreateForm.get('dv').hasError('required')">Campo obligatorio</mat-error>
			</mat-form-field>
		</div>
		<div class="mt-16" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" *ngIf="terceroCreateForm.get('tipoIdentificacion').value == 'NIT'">
			<mat-form-field appearance="outline" fxFlex>
				<mat-label>Razón Social*</mat-label>
				<mat-icon matSuffix>label</mat-icon>
				<input type="text" name="razonSocial" formControlName="razonSocial" matInput autocomplete="none">
				<mat-error *ngIf="terceroCreateForm.get('razonSocial').hasError('required')">Campo obligatorio</mat-error>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" *ngIf="terceroCreateForm.get('tipoIdentificacion').value != 'NIT'">
			<mat-form-field appearance="outline" fxFlex>
				<mat-label>Primer Nombre*</mat-label>
				<mat-icon matSuffix>label_important</mat-icon>
				<input type="text" name="primerNombre" formControlName="primerNombre" matInput autocomplete="none">
				<mat-error *ngIf="terceroCreateForm.get('primerNombre').hasError('required')">Campo obligatorio</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline" fxFlex>
				<mat-label>Otros Nombres</mat-label>
				<mat-icon matSuffix>label</mat-icon>
				<input type="text" name="segundoNombre" formControlName="segundoNombre" matInput autocomplete="none">
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" *ngIf="terceroCreateForm.get('tipoIdentificacion').value != 'NIT'">
			<mat-form-field appearance="outline" fxFlex>
				<mat-label>Primer Apellido*</mat-label>
				<mat-icon matSuffix>label_important</mat-icon>
				<input type="email" name="primerApellido" formControlName="primerApellido" matInput autocomplete="none">
				<mat-error *ngIf="terceroCreateForm.get('primerApellido').hasError('required')">Campo obligatorio</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline" fxFlex>
				<mat-label>Segundo Apellido*</mat-label>
				<mat-icon matSuffix>label</mat-icon>
				<input type="text" name="segundoApellido" formControlName="segundoApellido" matInput autocomplete="none">
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
			<mat-form-field appearance="outline" fxFlex='30'>
				<mat-label>Fecha de Nacimiento</mat-label>
				<input type="text" name="fechaNacimiento" formControlName="fechaNacimiento" matInput [matDatepicker]="pickerfechaNacimiento" [max]='dateNow'>
				<mat-datepicker-toggle matSuffix [for]="pickerfechaNacimiento"></mat-datepicker-toggle>
				<mat-datepicker #pickerfechaNacimiento></mat-datepicker>
				<!-- <mat-hint>Clic en el calendario para seleccionar la fecha</mat-hint> -->
				<mat-error *ngIf="terceroCreateForm.get('fechaNacimiento').hasError('required')">Campo obligatorio</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline" fxFlex='20'>
				<mat-label>Teléfono*</mat-label>
				<mat-icon matSuffix>phone_android</mat-icon>
				<input type="text" name="telefono" formControlName="telefono" matInput autocomplete="none">
				<mat-error *ngIf="terceroCreateForm.get('telefono').hasError('required')">Campo obligatorio</mat-error>
				<mat-error *ngIf="terceroCreateForm.get('telefono').hasError('minlength')">Mínimo 7 caracteres</mat-error>
				<mat-error *ngIf="terceroCreateForm.get('telefono').hasError('maxlength')">Máximo 10 caracteres</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline" fxFlex>
				<mat-label>Correo Electrónico*</mat-label>
				<mat-icon matPrefix>mail</mat-icon>
				<button matSuffix mat-icon-button matTooltipPosition='above' matTooltip="Esta dirección de correo electrónico será usada posteriormente para enviarle al tercero las credenciales de acceso al sistema (usuario y contraseña). EL correo electrónico debe ser único." autocomplete="none">
					<mat-icon>help</mat-icon>
				</button>
				<input type="text" name="email" formControlName="correoElectronico" matInput autocomplete="none">
				<mat-hint>Digite una dirección de correo válida donde el tercero tenga acceso</mat-hint>
				<mat-error *ngIf="terceroCreateForm.get('correoElectronico').hasError('required')">Campo obligatorio</mat-error>
				<mat-error *ngIf="terceroCreateForm.get('correoElectronico').hasError('email')">Formato invalido</mat-error>
			</mat-form-field>
		</div>
		<div class="mt-16" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
			<mat-form-field appearance="outline" fxFlex>
				<mat-label>Dirección*</mat-label>
				<mat-icon matSuffix>home</mat-icon>
				<input type="text" name="direccion" formControlName="direccion" matInput autocomplete="none">
				<mat-error *ngIf="terceroCreateForm.get('direccion').hasError('required')">Campo obligatorio</mat-error>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
			<mat-form-field appearance="outline" fxFlex>
				<mat-label>Departamento*</mat-label>
				<mat-icon matPrefix>business</mat-icon>
				<mat-select class="pl-12" name="departamento" formControlName="departamento" (selectionChange)="getMunicipios($event)">
					<mat-option *ngFor="let dpto of departamentos" [value]="dpto.codigo">{{dpto.nombre}}</mat-option>
				</mat-select>
				<mat-error *ngIf="terceroCreateForm.get('departamento').hasError('required')">Campo obligatorio</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline" fxFlex>
				<mat-label>Municipio*</mat-label>
				<mat-icon matPrefix>location_city</mat-icon>
				<mat-select class="pl-12" name="municipio" formControlName="municipio">
					<mat-option *ngFor="let mpio of municipios" [value]="mpio.codigo">{{mpio.nombre}}</mat-option>
				</mat-select>
				<mat-error *ngIf="terceroCreateForm.get('municipio').hasError('required')">Campo obligatorio</mat-error>
			</mat-form-field>
		</div>
	</form>
</div>